module.exports = __webpack_public_path__ + "img/Ellipse8.c0d9253b.png";